module.exports = __webpack_public_path__ + "static/media/7.f67472e7.jpg";